import React from 'react'
import Modal from 'react-modal';
import './LanguagesModal.css'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { ActionMeta, SingleValue } from 'react-select';

export const options = [
  { label: "🇪🇸 Español", code: "es", icon: "es"},
  { label: "🇺🇸 English", code: "en", icon: "us"},
  //{ label: "🇵🇹 Português", code: "pt", icon: "pt"},
];



export const LanguagesModal = (props: any) => {
  const modalClassName = props.isOpen ? 'modalLanguage active' : 'modalLanguage';
  const { i18n, t } = useTranslation();
  
  useEffect(() => {
    const len = localStorage.getItem("len");
    if (len) {
      i18n.changeLanguage(len);
    }
  }, [])

  const handleLanguageChange = (selected: SingleValue<{label: string;code: string;icon: string;}>, actionMeta: ActionMeta<any>) => {
      if (selected) {
        const lang_code = selected.code;
        i18n.changeLanguage(lang_code);
        localStorage.setItem("len", lang_code);
      } 
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      contentLabel="Language Modal"
      ariaHideApp={false}
      className={modalClassName}
    >
      <div className='languageContainer'>
        <button onClick={props.onClose} className="close-button">×</button>
        <div className='language'>
          <h1>{t('modal-languages.title')}:</h1>
          <div className="selectContainer">
            
            <Select
              defaultValue={options.find(option => option.code === i18n.language ? option.label : null)}
              isSearchable={false}
              options={options}

              onChange={handleLanguageChange}
              blurInputOnSelect
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>
          <h1><span className={`fi fi-${t('iconImg.icon')}`}></span> {t('iconImg.name')}</h1>     
        </div>
        <span>{t('iconImg.lang')}</span>  
      </div>
    </Modal>
  );
};